import {
  OperationStatus,
  OperationStatusLabel,
} from '@/context/services/invoice/type';
import {
  IconApproval,
  IconDelete,
  IconDraft,
  Tag,
} from '@moneyforward/ap-frontend-components';
import cx from 'classnames';
import { memo, type ReactNode } from 'react';
import styles from '../columns.module.scss';

type Props = {
  id: string;
  operationStatus: OperationStatus;
};

type StatusTag = {
  label: string | undefined;
  icon: ReactNode;
  iconClassName?: string;
};

const operationStatusTags: Record<OperationStatus, StatusTag> = {
  // The reason why "ocr_processing" is treated the same as "not_started" is because editing, deleting, and transferring to invoice_report cannot be performed.
  ocr_processing: {
    label: OperationStatusLabel.not_started,
    icon: <span className={styles['receivedInvoiceIdDot']} />,
    iconClassName: styles['receivedInvoiceIdIconNotStarted'],
  },
  not_started: {
    label: OperationStatusLabel.not_started,
    icon: <span className={styles['receivedInvoiceIdDot']} />,
    iconClassName: styles['receivedInvoiceIdIconNotStarted'],
  },
  applying: {
    label: OperationStatusLabel.applying,
    icon: <IconDraft size={12} />,
  },
  applied: {
    label: OperationStatusLabel.applied,
    icon: <IconApproval size={12} />,
    iconClassName: styles['receivedInvoiceIdIconApplied'],
  },
  archived: {
    label: OperationStatusLabel.archived,
    icon: <IconDelete size={12} />,
  },
};

export const ReceivedInvoiceIdCell = memo(({ id, operationStatus }: Props) => {
  const statusTag =
    operationStatusTags[operationStatus] ?? operationStatusTags.not_started;

  return (
    <>
      <p>IV-{id}</p>
      <Tag
        status='default'
        closable={false}
        outline={false}
        customIcon={
          <span
            className={cx(
              styles['receivedInvoiceIdIcon'],
              statusTag.iconClassName
            )}
          >
            {statusTag.icon}
          </span>
        }
      >
        {statusTag.label}
      </Tag>
    </>
  );
});

ReceivedInvoiceIdCell.displayName = 'ReceivedInvoiceIdCell';
